import { paramsDelEquipo, esRechazoDelEquipo } from './pos-equipo';
import bus from './bus-manager';

class HttpClient {
  constructor(client, store) {

    this.client = client;
    this.store = store;
  }

  getToken() {
    let token = localStorage.getItem('source_tk');
    if (token) {
      return token;
    }
    return null;
  }
  getTokenId() {
    let token = localStorage.getItem('tenant');
    if (token) {
      return token;
    }
    return null;
  }

  getHeaders() {
    //const tk = this.getToken();
    const tk = this.getToken();
    const tkId = this.getTokenId();
    let headers = {}
    if (tk) {
      headers = { 'Authorization': "Bearer " + tk, /*"Access-Control-Allow-Origin": "*", mode: 'cors' */ /*, 'authcmp': '6b49f698-01c9-65BB1B8997FAE21476E81EDADB38A'*/ };
    }
    if (tkId) {
      headers['x-tenant'] = tkId;
    }
    return headers;
  }

  /** Encabezados, y en las rutas de la caja el equipo y la caja (`plugins/pos-equipo.js`). */
  getConfig(path) {
    const config = { headers: this.getHeaders() };
    const params = paramsDelEquipo(path, this.store);
    if (params) {
      config.params = params;
    }
    return config;
  }

  getBaseUrl() {
    return process.env.VUE_APP_BASECONFIG_URL;
  }
  getAppVersion() {
    return process.env.VUE_APP_BASECONFIG_APP_VERSION;
  }

  getBaseUrlImagesCategoryProducts() {
    return process.env.VUE_APP_BASECONFIG_URL_CATEGORY;
  }

  getBaseUrlImagesNews() {
    return process.env.VUE_APP_BASECONFIG_URL_NEWS;
  }

  getBaseUrlImagesProducts() {
    return process.env.VUE_APP_BASECONFIG_URL_PRODUCTS;
  }

  getBaseUrlPublicFiles() {
    return process.env.VUE_APP_BASECONFIG_URL_PUBLIC_FILES;
  }

  put(path, params, loading, showMsgSuccess, showMsgError = true) {
    const config = this.getConfig(path);
    return new Promise((resolve, reject) => {
      if (this.store && loading) {
        this.store.commit('setLoading', true);
      }
      let url = process.env.VUE_APP_BASECONFIG_URL + path;
      if (path.indexOf('https') >= 0) {
        url = path;
      }
      this.client.post(url, params, config).then(response => {
        this.removeLoading();
        if (response.data.success > 0) {
          if (showMsgSuccess) {
            this.showMsg(response.data.msg);
          }
          resolve(response.data);
        } else {
          if (this.store && response.data.msg) {
            this.showError(response.data.msg);
          } else {
            this.showError('Ha ocurrido un error');
          }
          resolve(response.data);
        }
      }).catch(e => {
        this.removeLoading();
         let response = (e.response) ? e.response.data : null;
        if (showMsgError) {

          if (this.store && response && (response.msg || response.message)) {
            // if (showMsgSuccess) {
            let msg = response.msg || response.message;
            this.showError(msg);
            // }
          } else {

            // if (showMsgSuccess) {
            this.showError('Ha ocurrido un error');
            // }
          }
        }
        reject(e)
      });
    })
  }

  post(path, params, loading, showMsgSuccess, showMsgError = true) {
    const config = this.getConfig(path);
    return new Promise((resolve, reject) => {
      if (this.store && loading) {
        this.store.commit('setLoading', true);
      }
      let url = process.env.VUE_APP_BASECONFIG_URL + path;
      if (path.indexOf('https') >= 0) {
        url = path;
      }
      this.client.post(url, params, config).then(response => {
        this.removeLoading();
        //throw new Error('jijijiji')
        if (response.data.success > 0) {
          if (showMsgSuccess) {
            this.showMsg(response.data.msg);
          }
          resolve(response.data);
        } else {
          if (this.store && response.data.msg) {
            if (showMsgSuccess) {
              this.showError(response.data.msg);
            }
          } /*else {
            this.showError('Ha ocurrido un error');
          }*/
          resolve(response.data);
        }
      }).catch(e => {
        this.removeLoading();
        let response = (e.response) ? e.response.data : null;
        if (showMsgError) {

          if (this.store && response && (response.msg || response.message)) {
            // if (showMsgSuccess) {
            let msg = response.msg || response.message;
            this.showError(msg);
            // }
          } else {

            // if (showMsgSuccess) {
            this.showError('Ha ocurrido un error');
            // }
          }
        }
        reject(e)
      });
    })
  }

  /* postUrl(url, params){
     return this.client.post('http://localhost:5777/'+url, params);
   }
 
   getUrl(url, params){
     return this.client.get('http://localhost:5777/'+url);
   }*/

  postBasic(path, params) {
    const config = this.getConfig(path);
    return this.client.post(process.env.VUE_APP_BASECONFIG_URL + path, params, config);
  }

  queryReport(path, params) {
    const config = { headers: this.getHeaders() };
    return this.client.post(process.env.VUE_APP_BASECONFIG_URL_REPORT + path, params, config);
  }

  getRaw(path, loading, showMsgSuccess) {
    const config = this.getConfig(path);
    return new Promise((resolve, reject) => {
      if (this.store && loading) {
        this.store.commit('setLoading', true);
      }
      let url = process.env.VUE_APP_BASECONFIG_URL + path;
      if (path.indexOf('https') >= 0) {
        url = path;
      }
      this.client.get(url, config).then(response => {
        this.removeLoading();
        resolve(response.data);

      }).catch(e => {
        this.removeLoading();
        this.showError('Ha ocurrido un error');
        reject(e)
      });
    })
  }
  serializeQuery(params) {
    const value = {};
    for (const i in params) {
      if (Array.isArray(params[i])) {
        value[i] = params[i].map((item) => {
          if (item.id) {
            return { id: item.id };
          }
          return item;
        });
      } else {
        if (params[i] && params[i].id) {
          value[i] = { id: params[i].id };
        } else {
          value[i] = params[i];
        }
      }
    }
    return "params=" + JSON.stringify(value);
    //return new URLSearchParams(value).toString()
  }
  get(path, params, loading, showMsgSuccess, showMsgError = true) {
    const config = this.getConfig(path);
    return new Promise((resolve, reject) => {
      if (this.store && loading) {
        this.store.commit('setLoading', true);
      }
      if (this.store && !this.store.getters.online) {
        this.store.commit('setLoading', false);
        resolve({ 'success': false });
        return;
      }
      let url = process.env.VUE_APP_BASECONFIG_URL + path;
      if (path.indexOf('https') >= 0) {
        url = path;
      }
      if (params) {
        if (url.indexOf('?') >= 0) {
          url += '&' + this.serializeQuery(params);
        } else {
          url += '?' + this.serializeQuery(params);
        }
      }
      this.client.get(url, config).then(response => {
        this.removeLoading();
        if (response.data.success > 0) {
          if (showMsgSuccess) {
            this.store.commit('setMessage', response.data.msg);
          }
          resolve(response.data);
        } else {
          // `showMsgError` también vale aquí: hasta el 28 sep 2026 sólo se respetaba en el `catch`,
          // y la consulta silenciosa del estado de cuenta (plugins/estadoDeCuenta.js) le mostraba
          // «No existe un contrato para este cliente» a toda empresa sin suscripción al entrar.
          if (showMsgError) {
            if (this.store && response.data.msg) {
              this.showError(response.data.msg);
            } else {
              this.showError('Ha ocurrido un error');
            }
          }
          resolve(response.data);
        }
      }).catch(e => {
        this.removeLoading();
        let response = (e.response) ? e.response.data : null;
        if (showMsgError) {

          if (this.store && response && (response.msg || response.message)) {
            // if (showMsgSuccess) {
            let msg = response.msg || response.message;
            this.showError(msg);
            // }
          } else {

            // if (showMsgSuccess) {
            this.showError('Ha ocurrido un error');
            // }
          }
        }
        reject(e)
      });
    })
  }

  delete(path, params, loading, showMsgSuccess) {
    const config = { headers: this.getHeaders() };
    return new Promise((resolve, reject) => {
      if (this.store && loading) {
        this.store.commit('setLoading', true);
      }
      let url = process.env.VUE_APP_BASECONFIG_URL + path;
      if (path.indexOf('https') >= 0) {
        url = path;
      }
      this.client.delete(url, config).then(response => {
        this.removeLoading();
        if (response.data.success > 0) {
          if (showMsgSuccess) {
            this.showMsg(response.data.msg);
          }
          resolve(response.data);
        } else {
          this.removeLoading();
          if (this.store && response.data.msg) {
            this.showError(response.data.msg);
          } else {
            this.showError('Ha ocurrido un error');
          }
          resolve(response.data);
        }
      }).catch(e => {
        this.removeLoading();
        this.showError('Ha ocurrido un error');
        reject(e)

      });
    })
  }
  showMsg(msg) {
    if (this.store && msg) {
      this.store.commit('setMessage', msg);
    }
  }
  showError(msg) {
    console.log(msg);
    if (this.store && msg && msg != 'BLOCK_ACTION_PAYMMENT') {
      this.store.commit('setError', msg);
    }
    if (this.store && msg && msg == 'BLOCK_ACTION_PAYMMENT') {
      this.store.commit('setPaymentAnnouncement', true);
    }
  }
  removeLoading() {
    if (this.store) {
      this.store.commit('setLoading', false);
    }
  }

  upload(path, params) {
    const config = { headers: this.getHeaders() };
    config.headers['Content-Type'] = 'multipart/form-data;boundary=' + Math.random().toString().substr(2);
    return this.client.post(process.env.VUE_APP_BASECONFIG_URL + path, params, config);
  }
}
import axios from 'axios';

axios.interceptors.response.use(
  function (successRes) {
    if (successRes && successRes.data) {
      // Una venta devuelve las existencias de lo vendido ya descontadas (plugins/pos/existencias.js).
      if (successRes.data.item && successRes.data.item.existencias && /api\/v1\/order(\/|\?|$)/.test(successRes.config && successRes.config.url ? successRes.config.url.replace(/^https?:\/\/[^/]+\//, '') : '')) {
        bus.$emit('existencias', successRes.data.item.existencias);
      }
      if (successRes.data.event && successRes.data.event == 'killsession') {
        let sessKilled = localStorage.getItem('sk');
        if (!sessKilled) {
          localStorage.setItem('sk', 1);
          window.location.href = '/login';
        }
      }
    }
    return successRes;
  },
  function (error) {
    console.log(error);
    // La sesión venció (30 días sin usarse) o se cerró en otro lado: se vuelve a entrar. Sin esto la caja seguía con un
    // token muerto y cada petición fallaba con «Tu sesión venció»; la cola de la caja espera hasta que se entre.
    // Sólo si la petición que falló llevaba el token de ahora: una que salió sin token antes de entrar y contesta
    // después no puede tumbar la sesión recién abierta.
    if (error && error.response && error.response.data && error.response.data.code === 'AUTH.SESION.VENCIDA'
      && tokenDeLaPeticion(error.config) && tokenDeLaPeticion(error.config) === localStorage.getItem('source_tk')) {
      sesionVencida();
    }
    // La caja de este equipo está instalada en otro: el aviso ofrece instalar otra aquí (App.vue).
    // En la pantalla de instalación no hace falta: ahí basta con elegir otra caja.
    if (error && error.response && esRechazoDelEquipo(error.response.data) && storeDelEquipo && storeDelEquipo.getters.installation) {
      storeDelEquipo.commit('setEquipoRechazado', true);
    }
    return Promise.reject(error);
  }
);

let storeDelEquipo = null;

export default {
  install(Vue, options) {
    storeDelEquipo = options.store;

    Vue.prototype.$http = new HttpClient(axios, options.store);
  }

}

function tokenDeLaPeticion(config) {
  const h = (config && config.headers) || {};
  const valor = String(h.Authorization || h.authorization || '');
  return valor.replace(/^Bearer\s+/i, '') || null;
}

/** Una vez: borra la sesión de este equipo y lleva a entrar, con el motivo a la vista (Login.vue). */
function sesionVencida() {
  if (sesionVencida.yendo) {
    return;
  }
  sesionVencida.yendo = true;
  localStorage.removeItem('source_tk');
  localStorage.removeItem('profile');
  localStorage.setItem('aviso_login', 'Tu sesión venció. Entra otra vez con tu correo y tu contraseña.');
  window.location.href = '/';
}
